import React from 'react';

import ButtonChooser, { IButtonChooserProps } from './Chooser';
import ButtonOutline, { IButtonOutlineProps } from './Outline';
import ButtonPause, { IButtonPauseProps } from './Pause';
import ButtonPrimary, { IButtonPrimaryProps } from './Primary';
import ButtonTeamPicker, { IButtonTeamPickerProps } from './TeamPicker';

export type ButtonType = Partial<IButtonPauseProps> &
  Partial<IButtonPrimaryProps> &
  Partial<IButtonOutlineProps> &
  Partial<IButtonTeamPickerProps> &
  Partial<IButtonChooserProps>;

export const buttonTypes = (props: ButtonType) => ({
  pause: <ButtonPause {...props} />,
  primary: <ButtonPrimary {...props} />,
  outline: <ButtonOutline {...props} />,
  chooser: <ButtonChooser {...(props as IButtonChooserProps)} />,
  ['team-picker']: <ButtonTeamPicker {...(props as IButtonTeamPickerProps)} />,
});
